import { persist } from 'easy-peasy';
import cookies, { CookiesConsentModel } from './cookies.model';
import intl, { IntlModel } from './intl.model';
import sites, { SitesModel } from './sites.model';
import smartBuilding, { SmartBuildingModel } from './smartBuilding.model';
import tablePSIZNLmap, { TablePSIZNLModel } from './tablePSIZNL.model';
import userInfo, { UserInfoModel } from './user-info.model';
export interface AppStoreModel {
  intl: IntlModel;
  userInfo: UserInfoModel;
  sites: SitesModel;
  smartBuilding: SmartBuildingModel;
  tablePSIZNLmap: TablePSIZNLModel;
  cookies: CookiesConsentModel;
}

const model: AppStoreModel = persist(
  {
    intl,
    userInfo,
    sites,
    smartBuilding,
    tablePSIZNLmap,
    cookies,
  },
  { storage: 'localStorage' },
);

// 👇 export the typed hooks
export default model;
